+function ($) {
  'use strict';

  // HOVERDROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = '.dropdown-backdrop'
  var toggle   = '[data-toggle="hoverdropdown"]'
  var parent = '.dropdown'
  var HoverDropdown = function (element) {
    $(element).on('click.sn.hoverdropdown', this.toggle);
  }

  HoverDropdown.VERSION = '3.3.0'

  HoverDropdown.prototype.toggle = function (e) {
    var $this = $(this)

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    clearMenus()

    if (!isActive) {
      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
        // if mobile we use a backdrop because click events don't delegate
        $('<div class="dropdown-backdrop"/>').insertAfter($(this)).on('click', clearMenus)
      }

      var relatedTarget = { relatedTarget: this }
      $parent.trigger(e = $.Event('show.sn.hoverdropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this
        .trigger('focus')
        .attr('aria-expanded', 'true')

      $parent
        .toggleClass('open')
        .trigger('shown.sn.hoverdropdown', relatedTarget)
    }
    
    return false
  }

  function clearMenus(e) {
    if (e && e.which === 3) return
    $(backdrop).remove()
    $(toggle).each(function () {
      var $this         = $(this)
      var $parent       = getParent($this)
      var relatedTarget = { relatedTarget: this }

      if (!$parent.hasClass('open')) return

      $parent.trigger(e = $.Event('hide.sn.hoverdropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this.attr('aria-expanded', 'false')
      $parent.removeClass('open').trigger('hidden.sn.hoverdropdown', relatedTarget)
    })
  }

  function getParent($this) {
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = selector && $(selector)

    return $parent && $parent.length ? $parent : $this.parent()
  }


  // DROPDOWN PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('sn.hoverdropdown')

      if (!data) $this.data('sn.hoverdropdown', (data = new HoverDropdown(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.hoverdropdown

  $.fn.hoverdropdown             = Plugin
  $.fn.hoverdropdown.Constructor = HoverDropdown


  // DROPDOWN NO CONFLICT
  // ====================

  $.fn.hoverdropdown.noConflict = function () {
    $.fn.hoverdropdown = old
    return this
  }


  // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================

  $(document)
  	.on('mouseleave.sn.hoverdropdown.data-api', parent, HoverDropdown.prototype.toggle)
    .on('mouseover.sn.hoverdropdown.data-api', toggle, HoverDropdown.prototype.toggle)
}(jQuery);
